(() => {
  const root = document.querySelector('[data-ibg-welcome]');
  if (!root) return;
  const panel = root.querySelector('.ibg-welcome-panel');
  const teaser = root.querySelector('[data-ibg-open]');
  const form = root.querySelector('form');
  const key = 'ibg_welcome_v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
  const save = data => { try { localStorage.setItem(key, JSON.stringify({...read(), ...data})); } catch {} };
  let interactedAt = Date.now();
  let submitted = false;
  let opened = false;
  const blocker = () => document.hidden || document.querySelector('cart-drawer.active, .cart-notification.active, details[open].menu-opening, dialog[open], product-modal[open]') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
  const open = manual => {
    if (!manual && blocker()) return false;
    panel.hidden = false; teaser.hidden = true; teaser.setAttribute('aria-expanded', 'true'); opened = true;
    if (manual) root.querySelector('[data-ibg-close]').focus();
    return true;
  };
  const close = () => {
    panel.hidden = true; teaser.hidden = false; teaser.setAttribute('aria-expanded', 'false');
    save({dismissed: Date.now()}); teaser.focus({preventScroll:true});
  };
  teaser.addEventListener('click', () => open(true));
  root.querySelectorAll('[data-ibg-close]').forEach(el => el.addEventListener('click', close));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) close(); });
  ['pointerdown','keydown','change'].forEach(type => document.addEventListener(type, e => {
    if (!root.contains(e.target)) interactedAt = Date.now();
    if (e.target.closest('product-form, variant-selects, quantity-input, cart-items, cart-drawer') && !panel.hidden) {
      panel.hidden = true; teaser.hidden = false; teaser.setAttribute('aria-expanded', 'false');
    }
  }, {passive:true}));
  form?.addEventListener('submit', () => {
    submitted = true;
    try { sessionStorage.setItem('ibg_welcome_pending','1'); } catch {}
  });
  let pending = false;
  try { pending = sessionStorage.getItem('ibg_welcome_pending') === '1'; } catch {}
  if (root.querySelector('[data-ibg-success]') && pending) {
    save({subscribed:true});
    try { sessionStorage.removeItem('ibg_welcome_pending'); } catch {}
    open(true);
  } else if (root.querySelector('[data-ibg-errors]') && pending) {
    open(true);
  } else {
    const saved = read();
    if (root.dataset.subscribed === 'true' || saved.subscribed) { teaser.hidden = true; return; }
    const dismissed = Date.now() - (saved.dismissed || 0) < 7 * 86400000;
    if (dismissed || !['index','product','collection'].includes(root.dataset.page)) return;
    const started = Date.now();
    const timer = setInterval(() => {
      if (submitted || opened || Date.now() - started > 180000) { clearInterval(timer); return; }
      if (Date.now() - started >= Number(root.dataset.delay) * 1000 && Date.now() - interactedAt >= 8000 && open(false)) clearInterval(timer);
    }, 1000);
  }
})();
